import { defineComponent, reactive, watch, ref } from 'vue';
import { useService } from '@kaokei/use-vue-service';
import { QuestionService } from '@/services/exam/question.service';
import { logger } from '@/utils';
import Sentry from '@/utils/sentry';
import { ExamService } from '@/services/exam/exam.service';
export default defineComponent({
  name: 'WorkProfileDialog',
  setup: function setup() {
    var formRef = ref();
    var questionService = useService(QuestionService);
    var examService = useService(ExamService);

    var initFormState = function initFormState() {
      var questionId = questionService.question.id;
      var userAnswer = examService.getUserAnswerByQuestionId(questionId);
      formState.title = (userAnswer === null || userAnswer === void 0 ? void 0 : userAnswer.creationTitle) || '';
      formState.summary = (userAnswer === null || userAnswer === void 0 ? void 0 : userAnswer.creationSummary) || '';
    };

    var formState = reactive({
      title: '',
      summary: ''
    });
    var formRules = reactive({
      title: [{
        required: true,
        message: '请输入作品名',
        trigger: 'blur'
      }],
      summary: [{
        required: true,
        message: '请输入作品简介',
        trigger: 'blur'
      }]
    });

    var onSubmit = function onSubmit() {
      formRef.value.validate().then(function () {
        return questionService.saveProfile(formState.title, formState.summary).then(function () {
          questionService.hideWorkProfileDialog();
        });
      }).catch(function (e) {
        Sentry.withScope(function (scope) {
          scope.setContext('Exception', e);
          var level = e !== null && e !== void 0 && e.errorFields ? Sentry.Severity.Debug : Sentry.Severity.Error;
          scope.setLevel(level);
          Sentry.captureMessage('提交作品简介表单失败');
        });
        logger.debug('提交作品简介表单失败 => ', e);
      });
    }; // 监听登录弹窗是否关闭


    watch(function () {
      return questionService.workProfileDialogVisible;
    }, function (visible) {
      if (visible) {
        initFormState();
      } else {
        formRef.value.resetFields();
      }
    });
    return {
      labelCol: {
        span: 4
      },
      wrapperCol: {
        span: 20
      },
      onSubmit: onSubmit,
      questionService: questionService,
      formRef: formRef,
      formState: formState,
      formRules: formRules
    };
  }
});